module.exports = __webpack_public_path__ + "static/img/pttd_6@2x.473fb286.png";